
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dealers/[alias]",
      function () {
        return require("private-next-pages/dealers/[alias].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dealers/[alias]"])
      });
    }
  